export class CommonModel {
    over_booking_status: any;
    edit_price: boolean = false;
    specialityData: any;
    specialityName: any;
    speciality_id:any
    serviceId: any = '';
    service_code:any
    serviceItemCode: any;
    doctor_code : any;
    appointmentTime: any;
    serviceItem: any;
    is_group_limit_applicable:any;
    slotId: any = '';
    slotNo: any = '';
    slotTime: any;
    consult_package_items:any;
    service_package_items:any;
    serviceEndTime: any;
    serviceType_name: any;
    service_type_code: any;
    amount: any = 0;
    net_amount: any = 0;
    payer_amount: any = 0;
    patient_amount: any = 0;
    order_frequency: any;
    identifier:any;
    serviceData: any;
    priority: any = '';
    servicePriority: any = '';
    patient_instructions:any;
    nurse_remark:any;
    servicePrioritydata: any;
    serviceType: any = '';
    serviceType_code: any = '';
    package_type: any = '';
    package_sub_type: any = '';
    package_type_code: any = '';
    package_sub_type_code: any = '';
    quantity: any = 1;
    qty: number = 1;
    service_mrp: any;
    service_selling_amount: any;
    tariff_amount:any=''
    tariff_factor:any=''
    tariff_round_off_value:any=''
    nationality_factor:any=''
    single_visit: boolean = false;
    serviceSpeciality: any = '';
    specialityServiceData: any;
    serviceDoctor: any = '';
    serviceDoctorId: any = '';
    doctorServiceData: any;
    opd_type: any;
    opd_type_code: any = "";
    opdTypeData: any;
    auto_scheduling: boolean = false;
    consume_while_billing: boolean = false;
    billing: any = ""; 
    doctorRoomName: any;
    doctorFloorName: any;
    limit_per_day: any;
    template_id: any;
    template_name: any;
    template_type: any;
    template_sub_type: any;
    template_title: any;
    non_modifiable: any;
    cons_all_pkg_bill:any;
    token_at: any;
    allow_multiple_consumption: boolean = false;
    dependent_services:any;
    priorityList: any;
    priorityConfig: boolean = false;
    firstName: any;
    practitioner_id: any;

    searchDoctorArgs = {
        "complex_search": [
            {
                "label": "field.label.doctor",
                "key": "display_name",
            },
            {
                "label": "field.label.department",
                "key": "department_name"
            },
 
            {
                "label": "field.label.speciality",
                "key": "speciality"
            },
            {
                "label": "field.label.doctor_code",
                "key": "doctor_code"
            },
        ],
       
        "datasource": {
            "application": "facility-management",
            "resource": "schedule_event",
            "query_id": "GET_DOCTOR_BY_CARE_TYPE_V2",
            "key": "id",
            "order_by": "display_name",
            "args": "practice_type_code:individual",
            "template": "<div class='u-search-items position-relative border-bottom pl-2 pr-2 pb-1 pt-1'><div class='top-search-result  d-inline'>!!!display_name!!!</div><div class='float-right'>!!!partOfName!!!</div><span class='txt-13 pr-2 d-block'>!!!speciality!!! || !!!department_name!!! || !!!band_type_name!!!</span></div>"
        },
        "capitalise": true,
        "fields": ["display_name", "speciality","department_name","doctor_code", "band_type_name" ]
    }
    directDoctorArgs = {
        "complex_search": [
            {
                "label": "field.label.doctor",
                "key": "display_name",
            },
            {
                "label": "field.label.department",
                "key": "department_name"
            },
 
            {
                "label": "field.label.speciality",
                "key": "speciality"
            },
            {
                "label": "field.label.doctor_code",
                "key": "doctor_code"
            },
        ],
       
        "datasource": {
            "dependent_field": "treatingDoctorId",
            "resource": "practitioner_facility_details",
            "application": "facility-management",
            "filters": "is_direct_booking:true,status_code:active",
            "query_id": "GET_ALL",
            "template": "<div class='u-search-items position-relative border-bottom pl-2 pr-2 pb-1 pt-1'><div class='top-search-result  d-inline'>!!!display_name!!!</div><span class='txt-13 pr-2 d-block'>!!!speciality!!! || !!!department_name!!! || !!!doctor_code!!!</span><span class='txt-13 pr-2 d-block'>!!!band_type_name!!!</span></div>"
        },
        "capitalise": true,
        "fields": ["display_name", "speciality","department_name","doctor_code","band_type_name" ]
    }
    
    splitsearchDoctorArg = {
        "complex_search": [
            {
                "label": "field.label.doctor",
                "key": "display_name",
            },
            {
                "label": "field.label.department",
                "key": "department_name"
            },
 
            {
                "label": "field.label.speciality",
                "key": "speciality"
            },
            {
                "label": "field.label.doctor_code",
                "key": "doctor_code"
            }
        ],
       
        "datasource": {
            "application": "facility-management",
            "resource": "practitioner_facility_details_doctor",
            "query_id": "GET_DOCTOR_FOR_IP_SPLIT_BILL_SCREEN",
            "key": "id",
            "template": "<div class='u-search-items position-relative border-bottom pl-2 pr-2 pb-1 pt-1'><div class='top-search-result  d-inline'>!!!display_name!!!</div><div class='float-right'>!!!partOfName!!!</div><span class='txt-13 pr-2 d-block'>!!!speciality!!! || !!!department_name!!!</span></div>"
        },
        "capitalise": true,
        "fields": ["display_name", "speciality","department_name","doctor_code"]
    }
    
    searchDoctorArgsForProcedure = {
        "complex_search": [
            {
                "label": "field.label.doctor",
                "key": "display_name",
            },
 
            {
                "label": "field.label.speciality",
                "key": "speciality"
            },
            {
                "label": "field.label.doctor_code",
                "key": "doctor_code"
            }
        ],
       
        "datasource": {
            "application": "facility-management",
            "resource": "practitioner_facility_details_doctor",
            "key":"practitioner_id",
            "getterValue":"display_name",
            "query_id": "GET_DOCTOR_BY_FILTER",
            "order_by": "display_name",
            "template": "<div class='u-search-items position-relative border-bottom pl-2 pr-2 pb-1 pt-1'><div class='top-search-result  d-inline'>!!!display_name!!!</div><span class='txt-13 pr-2 d-block'>!!!speciality!!!"
        },
        "capitalise": true,
        "fields": ["display_name","speciality"]
    }
    searchOrdersetArgs = {
        "datasource": {
            "application": "emr",
            "resource": "order_set",
            "query_id": "ORDERSET_BY_PATIENT_TYPE",
            "args": "patientType:OP",
            "key": "id",
            "template": "<div class='u-search-items position-relative border-bottom pl-2 pr-2 pb-1 pt-1'><div class='top-search-result'>!!!name!!!</div></div>"
        },
        "capitalise": true,
        "fields": ["name"]
    }
    searchDepartmentArgs = {
        "datasource": {
            "application": "facility-management",
            "resource": "speciality_department_mapping_master",
            "query_id": "GET_DEPARTMENT_AND_PRICE",
            "key": "id",
            "template": "<div class='u-search-items position-relative border-bottom pl-2 pr-2 pb-1 pt-1'><div class='top-search-result'>!!!department_name!!!</div><span class='txt-13 pr-2'>!!!speciality!!!</span></div>"
        },
        "capitalise": true,
        "fields": ["department_name", "speciality"]
    }

    getAppointmentArgs = {
        "application": "",
        "resource": "",
        "query_id": "",
        "args": {
            "practitioner_id": "",
            "slot_date": 0,
            "slot_days": "",
            "service_type": "opd",
            "care_type": "",
            "practice_type": "individual",
            "department_id": "",
            "uhId": ""
        }
    }

    specialityArguments = {
        'args': {
            "doctorId": ""
        },
        "resource": "practitioner_facility_details_doctor",
        "application": "facility-management",
        "query_id": "GET_SPECIALITY_BY_DOCTOR"
    }
    specialityArgument = {
        'args': {
            "speciality_id": ""
        },
        "resource": "practitioner_facility_details_doctor",
        "application": "facility-management",
        "query_id": "GET_DOCTOR_BY_SPECIALITY"
    }

    opd_type_Arguments = {
        "args": {
            "module_name": "Appointment",
            "config_code": "opd_type",
            "status": "active"
        },
        "resource": "facility_config_mapping",
        "application": "facility-management",
        "query_id": "GET_MULTI_CONFIG_CODE",
    }


    getPrice = {
        "application": "facility-management",
        "resource": "op_amount",
        "action": "GET_AMOUNT"
    }
    searchSplitServices = {
        "complex_search": [
            {
                "label": "field.label.service_name",
                "key": "name",
            },
            {
                "label": "field.label.department",
                "key": "department_name"
            },
            {
                "label": "field.label.sub_department",
                "key": "subDepartment_name"
            },
            {
                "label": "field.label.service_type",
                "key": "serviceType"
            },
            {
                "label": "field.label.service_code",
                "key": "service_code"
            },
            {
                "label": "field.label.standard_codes",
                "key": "standard_codes.code_type_value"
            }
        ],
        "datasource": {
            "application": "facility-management",
            "resource": "catalog_entry",
            "query_id": "GET_BY_SERVICE_TYPE_EMR_V1",
            "args": "orderable:true,searchable:true,type:op,rule_context:op_billing,patientType:OP",
            "key": "id",
            "template": "<div class='u-search-items position-relative border-bottom pl-2 pr-2 pb-1 pt-1'><div class='top-search-result'>!!!name!!!</div><span class='txt-13 pr-2'>!!!serviceType!!! || !!!subDepartment_name!!! || !!!service_code!!!</span></div>"
        },
        "fields": ["name","subDepartment_name","department_name", "serviceType", "service_code","standard_codes"]
    }

    searchServices = {
        "complex_search": [
            {
                "label": "field.label.service_name",
                "key": "name",
            },
            {
                "label": "field.label.department",
                "key": "department_name"
            },
            {
                "label": "field.label.sub_department",
                "key": "subDepartment_name"
            },
            {
                "label": "field.label.service_type",
                "key": "serviceType"
            },
            {
                "label": "field.label.service_code",
                "key": "service_code"
            },
            {
                "label": "field.label.standard_codes",
                "key": "standard_codes.code_type_value"
            }
        ],
        multiSelect:true,
        "key":"name",
        checkKey:"serviceItemCode",
        multiTemplate:true,
        "datasource": {
            "application": "facility-management",
            "resource": "catalog_entry",
            "query_id": "GET_BY_SERVICE_TYPE_EMR_V1",
            "args": "orderable:true,searchable:true,type:op,rule_context:op_billing,patientType:OP",
            "key": "id",
            "page_size":60,
            "page_no":0,
            "template": "<div class='u-search-items position-relative pl-2 pr-2 pb-1 pt-1'><div class='top-search-result'>!!!name!!!</div><span class='txt-13 pr-2'>!!!serviceType!!! || !!!subDepartment_name!!! || !!!service_code!!!</span></div>"
        },
        "fields": ["name","subDepartment_name","department_name", "serviceType", "service_code","standard_codes"]
    }
    servicePriorityService = {
        "application": "facility-management",
        "resource": "facility_master",
        "query_id": "getOrganizationSetup",
        "args": {
            "facility_master_type": "SERVICEPRIORITY"
        },
    }
    servicespecialityService = {
        'args': {
            "facility_master_type": "SPECIALITYMASTER"
        },
        "resource": "facility_master",
        "application": "facility-management",
        "query_id": "getOrganizationSetup"
    }
    serviceDoctorService = {
        'args': {
            "specialityCode": ""
        },
        "resource": "practitioner_facility_details_doctor",
        "application": "facility-management",
        "query_id": "GET_DOCTOR_BY_SPECIALITY_CODE"
    }
    searchPHC = {
        "datasource": {
            "application": "facility-management",
            "resource": "phc_detail",
            "query_id": "GET_PACKAGES",
            "key": "id",
            "template": "<div class='u-search-items position-relative border-bottom pl-2 pr-2 pb-1 pt-1'><div class='top-search-result'>!!!phc_name!!!</div><span class='txt-13 pr-2'>!!!data!!!</span></div>"
        },
        "fields": ["phc_name", "data"]
    }
    searchVaccine = {
        "datasource": {
            "application": "facility-management",
            "resource": "vaccination_detail",
            "query_id": "GET_PACKAGES",
            "key": "id",
            "template": "<div class='u-search-items position-relative border-bottom pl-2 pr-2 pb-1 pt-1'><div class='top-search-result'>!!!phc_name!!!</div><span class='txt-13 pr-2'>!!!data!!!</span></div>"
        },
        "fields": ["phc_name", "data"]
    }
    getServiceType = {
        'args': {
            "facility_master_type": "SERVICETYPE"
        },
        "resource": "facility_master",
        "application": "facility-management",
        "query_id": "GET_SERVICE_TYPE"
    }
    getServiceTypeForMiscellaneousForOP = {
        'args': {
            "facility_master_type": "SERVICETYPEFORMISCELLANEOUS",
            "patientType":"OP"
        },
        "resource": "facility_master",
        "application": "facility-management",
        "query_id": "GET_SERVICE_TYPE_FOR_MISC"
    }
}
export class BillingModel {
    print_pop_up_config: boolean = false;
    // set only by the OP Billing screen; the tabs show "Last Visit Payer" when it has a value (#199302)
    lastVisitPayerName: string;
    orderId: any;
    edit_config: boolean = false;
    patientData: any;
    doctor_code:any
    amount: any = 0;
    mixData: any;
    netAmount: any = 0;
    discount: any = 0;
    total_amount: any = 0;
    bilDiscount: any = 0;
    practiceValue: any;
    // extraService: any;
    serviceDiscountApplicable: boolean = false;
    billDiscountApplicable: boolean = false;
    discountOn: any = '';
    discount_type: any = '';
    payerId: any = 'xyz';
    payer_type: any = '';
    payment_typeId: any;
    payer_payment_type: any;
    payerName: any;
    schemeId: any = '';
    schemeName: any;
    scheme_type : any;
    ivf_no : any
    copay_details:any;
    care_plan_discount_apply:boolean = false;
    referredById: any = '';
    referType: any = '';
    isFacilityOrPerson: any = '';
    referredByName: any = '';
    doctorName: any;
    referType_name: any;
    specialityName: any;
    appointmentTime: any;
    scheme_discount_applicable: any;
    referred_by_name: any;
    referType_display:any;
    tokenId: any = '';
    tokenNumber: any;
    authorizedId: any = '';
    authorizedName: any;
    depositName: any;
    totalAmount: any;
    isDiscountApplied: boolean = false;
    consume_while_billing: boolean = false;
    discountAuthorizedById: any = '';
    discountAuthorizedByName: any;
    slotId: any = '';
    treating_doctor: any = '';
    treatingDoctor: any;
    treatingDoctorId: any = 'xyz';
    tariff_id:any='';
    tariff_name:any='';
    treatingDoctorSpeciality: any = '';
    treatingDoctorSpecialityCode: any = '';
    gettreatingDoctorData: any = '';
    slotTime: any;
    override_scheme:boolean = false;
    paymentDetails: any;
    referByName: string;
    getPayerData: any;
    getFacilitatorData: any;
    configValue:any;
    remarks:any;
    billNo:any;
    getPayerArgs = {
        "application": "facility-management",
        "resource": "payer",
        "query_id": "GET_PAYER",
    }
    getReferralTypeData: any
    getReferralNamesData: any;
    getReferralTypes: any;
    getReferralNamesArgs = {
        "application": "facility-management",
        "resource": "refer",
        "query_id": "GET_REFER_BY_REFERTYPE",
        "args": {
            "status": "active"
        }
    }
    FacilitatorService = {
        "application": "facility-management",
        "resource": "refer",
        "query_id": "GET_REFER_BY_REFERTYPE",
        "args": {
            "status": "active",
            "referType": "facilitator"
        }
    }
    dataTableData: Array<any> = [];
    dataTableDataFailed: Array<any> = [];
    fields: any[];
    failed_fields: any[];

    payerInputData: any;
    discountType: any = '';
    facilitatorId: any = '';
    facilitatorName: any = '';
    cardNo: any
    tariff_amount:any=''
    tariff_factor:any=''
    tariff_round_off_value:any=''
    nationality_factor:any=''
    selectedService: any = "consultation";
    payer_base_tariff_id: any;
    duplicate_sv_cn:any;
    emergencyHolidayCharges: any;
    emergencyHoidayCharges: any;
    is_auto_scheduling: boolean = false;
    allow_multiple_consumption: boolean = false;
    package_billing_type: any = ""; 
  admissionId: any;
  services: any;
  carePlan_name: any;
  is_discount_from_ui: boolean = false;
}

export class BillingConsultation extends CommonModel {
  patientTypeCode: any;
  instruction: any;
  wing_name:any;
  care_plan_discount_apply: boolean = false;
}

export class PHCPackages extends CommonModel {
  service_code: any;

}
export class OPServices extends CommonModel {

}

export class miscServices extends CommonModel {

}